export default __webpack_public_path__ + "static/media/amazon-logo.292697ab.png";